import Subtasks from './Subtasks';
import JiraProjects from './JiraProjects';
import JiraIssues from './JiraIssues';
const Generate = () => {

  return (
    <div data-testid="test-generate" className="flex h-full">
      <div className="flex w-full flex-col gap-2 lg:flex-row">
        {/* BOX 1 */}
        <div
          data-testid="test-generator-box-1"
          className="flex h-full w-full flex-col gap-2 lg:w-2/5"
        >
          <JiraProjects
            showPromptCrud={true}
          />
          <JiraIssues />
        </div>

        {/* BOX 2 */}
        <div
          data-testid="test-generator-box-2"
          className="flex h-full w-full flex-col gap-2 lg:w-3/5"
        >
          <Subtasks />
        </div>
      </div>
    </div>
  );
};

export default Generate;
